import { render, staticRenderFns } from "./title.vue?vue&type=template&id=6b8f1388&scoped=true&"
import script from "./title.vue?vue&type=script&lang=js&"
export * from "./title.vue?vue&type=script&lang=js&"
import style0 from "./title.vue?vue&type=style&index=0&id=6b8f1388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8f1388",
  null
  
)

export default component.exports